import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { AssetSubStatus, IconWithTooltip,DefaultDateFormat, } from "../../../helper/fixcode";
import { Template } from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import { Icon } from "@iconify/react";
import { askConfirmation, showResponseMessage } from "../../../helper/message";
import { Loader } from "../../Shared/PageLoader";
import moment from "moment";

export default function AssetPurchaseRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [state, setState] = useState({
        isCompleteLoading: false,
        loadingMessage: "",
    });
  const [assetPurchaseRequestList, setAssetPurchaseRequestList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Upload To SAP";
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getPurchaseRequestLst();
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getPurchaseRequestLst = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      let body = {
        requestPurchaseId: 0,
        userId: user?.userId,
      };

      const response = await assetService.getAssetPurchaseRequestList(body);
      //console.log(JSON.stringify(response?.data));
      const approvedStatusId = Number(AssetSubStatus.AssetPurchaseRequestApproved);
      //const data = response?.data?.filter((request) => request.statusId !== approvedStatusId && !request.isSendToSap && request.actionAllowed === true);
      const data = response?.data?.filter((request) => request.statusId !== approvedStatusId && !request.isSendToSap);
      setAssetPurchaseRequestList(data);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={assetPurchaseRequestList}
              ref={refDataGrid}
              keyExpr="assetRequestId"
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  //   {
                  //     location: "before",
                  //     template: "toolbarAddTemplate",
                  //   },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                  //   {
                  //     location: "after",
                  //     widget: "dxButton",
                  //     options: {
                  //       icon: "refresh",
                  //       onClick: async () => {
                  //         await getMovementRequestLst();
                  //       },
                  //     },
                  //   }
                );
              }}
            >
              <Column
                dataField="requestPurchaseId"
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                width={130}
                cellRender={(cellData) => {
                  const rowData = cellData?.data;
                  const idPrefix = `icon-${rowData?.requestPurchaseId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (rowData?.movementTypeId === 1) {
                                    navigate(
                                      rowData?.quotationTypeId === 1
                                        ? "/asset-purchase-preview"
                                        : "/asset-hire-preview",
                                      {
                                        state: {
                                          requestQuotationId:
                                            rowData?.assetQuotationId,
                                          quotationIndentNo:
                                            rowData?.purchaseIndentNo,
                                          quotationTypeId:
                                            rowData?.quotationTypeId,
                                          sourceUrl:
                                            rowData?.quotationTypeId === 1
                                              ? "UploadSAPRequestAssetPurchase"
                                              : rowData?.quotationTypeId === 2
                                              ? "UploadSAPRequestAssetHire"
                                              : "",
                                          isReport: false,
                                        },
                                      }
                                    );
                                  } else if (rowData?.movementTypeId === 2) {
                                    navigate("/asset-movement-preview", {
                                      state: {
                                        requestMovementId:
                                          rowData?.requestPurchaseId,
                                        movementIndentNo:
                                          rowData?.purchaseIndentNo,
                                        sourceUrl: "UploadSAPAssetMovement",
                                        isReport: false,
                                      },
                                    });
                                  } else if (rowData?.movementTypeId === 3) {
                                    navigate(
                                      "/material-movement-order-preview",
                                      {
                                        state: {
                                          requestMovementId:
                                            rowData?.requestPurchaseId,
                                          materialMovementOrderIndentNo:
                                            rowData?.purchaseIndentNo,
                                          sourceUrl:
                                            "UploadSAPMaterialMovementOrder",
                                          isReport: false,
                                        },
                                      }
                                    );
                                  }
                                }}
                              />
                            </span>
                          </>
                        )}
                        &nbsp;
                        <span>
                          {
                          //rowData.departmentId === user?.userDepartmentId && (
                          rowData.actionAllowed && (
                            <button
                              style={{ cursor: "pointer" }}
                              type="button"
                              title="Action"
                              className="btn btn-primary btn-sm-1"
                              onClick={async (e) => {
                                e.preventDefault();
                                let confirmationQuestion = `<span style='font-size:16px;'>Are you sure you want to send ${
                                  rowData?.movementTypeId === 1
                                    ? `${
                                        rowData?.ownershipTypeId === 1
                                          ? `purchase`
                                          : `hire`
                                      }`
                                    : `movement`
                                } request [${
                                  rowData?.purchaseIndentNo
                                }] to SAP as

                                 ${
                                //   rowData?.movementTypeId === 1
                                //     ? `of PR type - [${rowData?.ownershipType}]`
                                //     : `of type - [${rowData?.transportationName}]`
                                // }  to SAP?</span>`;

                                  rowData?.movementTypeId === 1 ? rowData?.ownershipTypeId === 1
                                    ? ` Purchase order`
                                    : ` Service order`
                                    : ` Movement order`
                                }?`;

                                let isConfirmed = await askConfirmation(
                                  confirmationQuestion,
                                  "Yes",
                                  "No"
                                );

                                if (!isConfirmed) return;
                                const response =
                                  await assetService.importSAPDetails(
                                    rowData?.requestPurchaseId,
                                    rowData?.movementTypeId
                                  );
                                isConfirmed = await showResponseMessage(
                                  response
                                );
                                if (response?.isSuccess) {
                                  await getPurchaseRequestLst();
                                }
                                try {
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              <Icon
                                className="iconify-size mr-1"
                                icon="material-symbols:send"
                                width="14"
                                height="14"
                              />
                              &nbsp;Send To SAP
                            </button>
                          )}
                        </span>
                      </div>
                    </>
                  );
                }}
              ></Column>
              <Column
                dataField="movementTypeName"
                caption="Request Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="purchaseIndentNo"
                caption="Order No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="purchaseRequestNo"
                caption="Purchase No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="sapStatusName"
                caption="SAP Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  var lastUpdatedDate = "";
                  if (!e?.data?.updatedOn) {
                    lastUpdatedDate = moment(e?.data?.createdOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                  }
                  else {
                    const parsedDate = new Date(e?.data?.updatedOn);
                    if (isNaN(parsedDate.getTime())) {
                      lastUpdatedDate = moment(e?.data?.updatedOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    const minDate = new Date("0001-01-01T00:00:00");
                    if (parsedDate.getTime() === minDate.getTime()) {
                      lastUpdatedDate = moment(e?.data?.createdOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    else {
                      lastUpdatedDate = moment(e?.data?.updatedOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                  }
                  return (
                    <div>
                      <span>{e.data?.sapStatusName}</span>
                      {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                                        {e.data?.currentUserId > 0
                                          ? e.data?.currentUserName
                                          : e.data?.fromName}
                                      </div> */}
                      <br />
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {lastUpdatedDate}
                      </div>
                    </div>
                  );
                }}
              />
              {/* <Column
                dataField="importPrStatus"
                caption="Import Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="assetDescriptions"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="assetStatusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestDrafted
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestPending
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestSentforApproval
                  )
                    color = "#FF9800";

                  return (
                    <div>
                      <span style={{ color }}>{e.data?.assetStatusName}</span>
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.fromName}
                      </div>
                    </div>
                  );
                }}
              /> */}
              <Column
                dataField="ownershipType"
                caption="PR Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
              />
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add Movement Request"
                        className="btn btn-primary btn-sm mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          try {
                            navigate("/AddAssetRequest");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <span title="Add Movement Request">
                          <i className="fas fa-plus"></i>
                          &nbsp;&nbsp;Add
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getPurchaseRequestLst();
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Asset Quotation" />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
